import moment from "moment";
import Vue from "vue";

Vue.filter("formatDateTime", (value,format) => {
  if (value) {
    return moment(value).format(format);
  }
});
